import { PreRegistrationPatientInfoEntity } from "@/domain/entity/pre-regitration-patient-info-entity";
import { FetchApiClientMethod } from "@sadtx/fetch-api-client";
import { errorConverter, SATError, SATResult } from "@sadtx/sat-error";
import { PreRegistrationInfoResponseDto } from "../dto/pre-registration-info-response-dto";
import { PreRegistrationEncyptedPayload } from "../payload/pre-registration-request-payload";
import { URLList } from "../url_list";

/**
 * 사전 등록 관련 API 요청을 담당하는 데이터 소스 클래스
 */
export class PreRegistrationSource {
  constructor(private readonly client: FetchApiClientMethod) {}

  /**
   * 환자 및 보호자 사전 등록
   * @param payload - 암호화된 사전 등록 정보
   * @returns 성공 시 void, 실패 시 SATError
   */
  async createPreRegistration(
    token: string,
    payload: PreRegistrationEncyptedPayload
  ): Promise<SATResult<void, SATError>> {
    try {
      console.log("[PreRegistrationSource] :: createPreRegistration :: 사전 등록 요청 시작");
      const url = `${URLList.PREREGISTRATION.CREATE}/${token}`;
      const response = await this.client.post(url, payload);
      console.log(
        "[PreRegistrationSource] :: createPreRegistration :: 사전 등록 요청 성공",
        response.data
      );
      return SATResult.success(void 0);
    } catch (error: unknown) {
      console.error(
        "[PreRegistrationSource] :: createPreRegistration :: 사전 등록 요청 실패",
        error
      );
      const satError = errorConverter.convertError(error);
      console.log("[PreRegistrationSource] :: createPreRegistration | ", satError);
      return SATResult.failure(satError);
    }
  }

  /**
   * 사전 등록 정보 조회
   * @param token - 사전 등록 토큰
   * @returns 성공 시 PreRegistrationInfoResponseDto, 실패 시 SATError
   */
  async getPreRegistrationList(): Promise<
    SATResult<PreRegistrationInfoResponseDto[], SATError>
  > {
    try {
      const url = URLList.PREREGISTRATION.GET;
      console.log("[PreRegistrationSource] :: getPreRegistration :: 사전 등록 정보 조회 시작", url);
      const response = await this.client.get(url);
      console.log(
        "[PreRegistrationSource] :: getPreRegistration :: 사전 등록 정보 조회 성공",
        response.data
      );
      return SATResult.success(response.data);
    } catch (error: unknown) {
      console.error(
        "[PreRegistrationSource] :: getPreRegistration :: 사전 등록 정보 조회 실패",
        error
      );
      const satError = errorConverter.convertError(error);
      console.log("[PreRegistrationSource] :: getPreRegistration | ", satError);
      return SATResult.failure(satError);
    }
  }

  async getPreRegistrationPatientInfo(
    uuid: string
  ): Promise<SATResult<PreRegistrationPatientInfoEntity, SATError>> {
    try {
      const url = `${URLList.PREREGISTRATION.GET}/${uuid}`;
      console.log(
        "[PreRegistrationSource] :: getPreRegistrationPatientInfo :: 사전 등록 환자 정보 조회 시작",
        url
      );
      const response = await this.client.get(url);
      console.log(
        "[PreRegistrationSource] :: getPreRegistrationPatientInfo :: 사전 등록 환자 정보 조회 성공",
        response.data
      );
      return SATResult.success(response.data);
    } catch (error: unknown) {
      console.error(
        "[PreRegistrationSource] :: getPreRegistrationPatientInfo :: 사전 등록 환자 정보 조회 실패",
        error
      );
      const satError = errorConverter.convertError(error);
      console.log("[PreRegistrationSource] :: getPreRegistrationPatientInfo | ", satError);
      return SATResult.failure(satError);
    }
  }

  /**
   * 사전 등록 정보 수정
   * @param uuid - 사전 등록 uuid
   * @param payload - 수정할 사전 등록 정보
   * @returns 성공 시 void, 실패 시 SATError
   */
  async confirmPreRegistration(uuid: string): Promise<SATResult<void, SATError>> {
    console.log(
      "[PreRegistrationSource] :: confirmPreRegistration :: 사전 등록 정보 수정 시작",
      uuid
    );
    console.log("[PreRegistrationSource] :: confirmPreRegistration :: 미구현");
    return SATResult.success(void 0);

    // try {
    //   const url = `${URLList.PREREGISTRATION.UPDATE}/${uuid}`;
    //   console.log("[PreRegistrationSource] :: updatePreRegistration :: 사전 등록 정보 수정 시작", url);
    //   const response = await this.client.put(url);
    //   console.log("[PreRegistrationSource] :: updatePreRegistration :: 사전 등록 정보 수정 성공", response.data);
    //   return SATResult.success(void 0);
    // } catch (error: unknown) {
    //   console.error("[PreRegistrationSource] :: updatePreRegistration :: 사전 등록 정보 수정 실패", error);
    //   const satError = errorConverter.convertError(error);
    //   console.log("[PreRegistrationSource] :: updatePreRegistration | ", satError);
    //   return SATResult.failure(satError);
    // }
  }

  /**
   * 사전 등록 정보 삭제
   * @param uuid - 사전 등록 uuid
   * @returns 성공 시 void, 실패 시 SATError
   */
  async deletePreRegistration(uuid: string): Promise<SATResult<void, SATError>> {
    try {
      const url = `${URLList.PREREGISTRATION.DELETE}/${uuid}`;
      console.log(
        "[PreRegistrationSource] :: deletePreRegistration :: 사전 등록 정보 삭제 시작",
        url
      );
      const response = await this.client.delete(url);
      console.log(
        "[PreRegistrationSource] :: deletePreRegistration :: 사전 등록 정보 삭제 성공",
        response.data
      );
      return SATResult.success(void 0);
    } catch (error: unknown) {
      console.error(
        "[PreRegistrationSource] :: deletePreRegistration :: 사전 등록 정보 삭제 실패",
        error
      );
      const satError = errorConverter.convertError(error);
      console.log("[PreRegistrationSource] :: deletePreRegistration | ", satError);
      return SATResult.failure(satError);
    }
  }
}
